import { API_PREFIX } from '../config'

const api = {
    //webview 首页跳到数聚时尚的地址
    sjssUrl: API_PREFIX.sjssUrl,
    // 图片预览地址前缀
    imgPrev: API_PREFIX.imgPrev,
    // 衣加加接口地址
    yjjApi: API_PREFIX.yjjApi,

	// 线上支付接口地址
	onlinePayUrl: API_PREFIX.yjjPayApi + '/v1/api/pay/gateway',
	// 线上退款接口地址
	onlineRefundUrl: API_PREFIX.yjjPayApi + '/v1/api/pay/allRefundOrder',
	// 线上支付接口地址 -pc
	pcPayUrl: API_PREFIX.yjjPayApi + '/v1/api/pay/gatewayByPc',
	// 判断是否支付
	isPay: API_PREFIX.yjjPayApi + '/v2/api/isPay',
	
    
	// 获取快捷登录注册短信验证码
	requestPhoneCode: API_PREFIX.yjjApi + '/yijiajiaUserInfo/RequestPhoneCode',
	// 获取忘记密码短信验证码
	requestForgetPasswdCode: API_PREFIX.yjjApi + '/yijiajiaUserInfo/RequestForgetPasswdCode',
	// 用户手机号快捷注册登录
	phoneNumberLoginOrRegiste: API_PREFIX.yjjApi + '/yijiajiaUserInfo/PhoneNumberLoginOrRegiste',
	// 注册选择身份和设置密码
	requestRegistUser: API_PREFIX.yjjApi + '/yijiajiaUserInfo/RequestRegistUser',
	// 注册时品类提交
	regData: API_PREFIX.yjjApi + '/yijiajiaUserInfo/regData',
	// 用户账号密码登录
	requestAccountPasswdLogin: API_PREFIX.yjjApi + '/yijiajiaUserInfo/RequestAccountPasswdLogin',
	// 用户登录入口--忘记密码接口
	requestForgetPassWd: API_PREFIX.yjjApi + '/yijiajiaUserInfo/RequestForgetPassWd',
	// 退出登录
	userSignOut: API_PREFIX.yjjApi + '/yijiajiaUserToken/userSignOut',
	
	
	
	//服务反馈 aboutYijiajiaApp/addServiceFeedBack
	addServiceFeedBack: API_PREFIX.yjjApi + '/aboutYijiajiaApp/addServiceFeedBack',
	//个人中心修改密码
	requestUpdatePassWd: API_PREFIX.yjjApi + '/yijiajiaUserInfo/RequestUpdatePassWd',
		// 个人中心-检查更新
	checkUpdate: API_PREFIX.yjjApi + '/aboutYijiajiaApp/checkUpdate',
		// 个人中心-联系客服
	contactService: API_PREFIX.yjjApi + '/aboutYijiajiaApp/contactService',
		// 个人中心-地址-获取省市区三级联动
	regionInfo: API_PREFIX.yjjApi + '/globalRegionInfo/regionInfo',
	// 个人中心-地址-添加地址
	addUserAddress: API_PREFIX.yjjApi + '/yijiajiaUserAddress/addUserAddress' ,
	// 个人中心-地址-地址列表
	requestUserAddressList: API_PREFIX.yjjApi + '/yijiajiaUserAddress/requestUserAddressList' ,
		// 个人中心-地址-设置默认地址
	requestUserDefaultAddress: API_PREFIX.yjjApi + '/yijiajiaUserAddress/requestUserDefaultAddress' ,
		// 个人中心-地址-删除地址
	delUserAddress: API_PREFIX.yjjApi + '/yijiajiaUserAddress/delUserAddress' ,
		// 个人中心-地址-编辑地址
	updateAddressByAddressId: API_PREFIX.yjjApi + '/yijiajiaUserAddress/updateAddressByAddressId' ,
	//个人中心-地址-编辑地址-获取地址详情
	findUserAddressByAId: API_PREFIX.yjjApi + '/yijiajiaUserAddress/findUserAddressByAId' ,
	//个人中心-基础资料myInfo
	findUserAuthInfo: API_PREFIX.yjjApi + '/yijiajiaUserAuth/findUserAuthInfo' ,
	//个人中心-基础资料_一个只查头像和公司姓名电话的简单接口
	findUserInfo: API_PREFIX.yjjApi + '/yijiajiaUserAuth/findUserInfo' ,
	
	
	//个人中心-基础资料-人员设备增加
	addStaffDevice: API_PREFIX.yjjApi + '/yijiajiaUserInfo/addStaffDevice' ,
	//生产商查看确认验收结果页面显示
	confirmAcceptanceResultsshow: API_PREFIX.yjjApi + '/yijiajiaOrder/confirmAcceptanceResultsshow' ,
	//被拒绝后重新提交认证信息
	editUserAuthInfo: API_PREFIX.yjjApi + '/yijiajiaUserAuth/editUserAuthInfo' ,
	
	//基础资料修改品类工艺（生产商）
	editExtraUserInfo: API_PREFIX.yjjApi + '/yijiajiaUserInfo/editExtraUserInfo' ,
	
	
	//品牌商生产商提交认证(营业执照)
	subUserAuth: API_PREFIX.yjjApi + '/yijiajiaUserAuth/subUserAuth' ,
		//上传图片
	uploadfilebatch: API_PREFIX.yjjApi + '/file/uploadfilebatch' ,
		//接加工订单列表(生产商)
	requestMachiningOrderlist: API_PREFIX.yjjApi + '/yijiajiaOrder/requestMachiningOrderlist' ,
		//优选订单列表(生产商)
	priorityPushOrderList: API_PREFIX.yjjApi + '/yijiajiaOrder/priorityPushOrderList' ,
	
		//接加工订单 (生产商) 
	receiveMachiningOrder: API_PREFIX.yjjApi + '/yijiajiaOrder/receiveMachiningOrder' ,
		//接加工订单时生产商是否交付了2%的定金 
	orderTakingFeeIsPaid: API_PREFIX.yjjApi + '/yijiajiaOrder/orderTakingFeeIsPaid' ,
	
	
		//订单详情：生产商，品牌商，草稿
	findOrderByONumber: API_PREFIX.yjjApi + '/yijiajiaOrder/findOrderByONumber' ,
		//订单列表 ：品牌商
	requestUserOrderList: API_PREFIX.yjjApi + '/yijiajiaOrder/requestUserOrderList' ,
	//订单列表 ：生产商
	requestshengchanUserOrderList: API_PREFIX.yjjApi + '/yijiajiaOrder/requestshengchanUserOrderList' ,
	//订单进度-生产商
	orderProgressShengchan: API_PREFIX.yjjApi + '/yijiajiaOrder/orderProgressShengchan' ,
	//交付大货-生产商品
	deliverLargeGoods: API_PREFIX.yjjApi + '/yijiajiaOrder/deliverLargeGoods' ,

	
	//根据订单号获取简单的信息：订单名称，状态等
	getOrderInfo: API_PREFIX.yjjApi + '/yijiajiaOrder/getOrderInfo' ,
	//取消订单-生产商-品牌商
	cancelOrder: API_PREFIX.yjjApi + '/yijiajiaOrder/cancelOrder' ,
	//获取信息：确认预付款凭证，确认交货款凭证，确认尾款凭证,确认合同，联系商家
	paymentRemarkShow: API_PREFIX.yjjApi + '/yijiajiaOrder/paymentRemarkShow' ,
	//确认合同-生产商
	confirmContract: API_PREFIX.yjjApi + '/yijiajiaOrder/confirmContract' ,
	//确认预付款-生产商
	confirmCertificate: API_PREFIX.yjjApi + '/yijiajiaOrder/confirmCertificate' ,
	//交付大货-生产商
	deliverLargeGoods: API_PREFIX.yjjApi + '/yijiajiaOrder/deliverLargeGoods' ,
	//确认验收结果-生产商
	confirmAcceptanceResults: API_PREFIX.yjjApi + '/yijiajiaOrder/confirmAcceptanceResults' ,
	//确认交货款-生产商
	confirmDelivery: API_PREFIX.yjjApi + '/yijiajiaOrder/confirmDelivery' ,
	//确认尾款-生产商
	confirmTail: API_PREFIX.yjjApi + '/yijiajiaOrder/confirmTail' ,
	//评价-生产商和品牌商
	evaluation: API_PREFIX.yjjApi + '/yijiajiaOrder/evaluation' ,
	//获取系统消息
	getSystemInfo: API_PREFIX.yjjApi + '/yijiajiaOrder/getSystemInfo' ,

	
	// 获取订单进度页 - 品牌商
	orderProgressPinpai: API_PREFIX.yjjApi + '/yijiajiaOrder/orderProgressPinpai',
	// 确认此厂 - 品牌商
	confirmFactory: API_PREFIX.yjjApi + '/yijiajiaOrder/confirmFactory',
	// 填写详细资料（补充资料） - 品牌商
	additionalmaterials: API_PREFIX.yjjApi + '/yijiajiaOrder/additionalmaterials',
	// 填写上传合同  - 品牌商
	uploadContract: API_PREFIX.yjjApi + '/yijiajiaOrder/uploadContract',
	// 预付款凭证  - 品牌商
	prepaymentCertificate: API_PREFIX.yjjApi + '/yijiajiaOrder/prepaymentCertificate',
	// 提交验收结果  - 品牌商
	submitAcceptanceResults: API_PREFIX.yjjApi + '/yijiajiaOrder/submitAcceptanceResults',
	// 交货款凭证  - 品牌商
	deliveryCertificate: API_PREFIX.yjjApi + '/yijiajiaOrder/deliveryCertificate',
	// 尾款凭证  - 品牌商
	tailCertificate: API_PREFIX.yjjApi + '/yijiajiaOrder/tailCertificate',
	// 更改品类  - 品牌商
	editExtraInfo: API_PREFIX.yjjApi + '/yijiajiaUserInfo/editExtraInfo',
	// 优先推送  - 品牌商
	chosePushUser: API_PREFIX.yjjApi + '/yijiajiaOrder/chosePushUser',

	
	// 获取源数据
	getDatasource: API_PREFIX.yjjApi + '/yijiajiaDataCategory/getDatasource',
	// 品牌商获取品牌
	showUserAuthBrand: API_PREFIX.yjjApi + '/yijiajiaUserAuth/showUserAuthBrand',
	// 款式分类
	categoryInfo: API_PREFIX.yjjApi + '/yijiajiaDataCategory/categoryInfo',
	// 生产商列表
	producerList: API_PREFIX.yjjApi + '/yijiajiaUserAuth/producerList',
	// 生产商详情
	findProducerInfo: API_PREFIX.yjjApi + '/yijiajiaUserAuth/findProducerInfo',
	// 发布订单 （初始 => 草稿/订单）
	publishOrder: API_PREFIX.yjjApi + '/yijiajiaOrder/publishOrder',
	// 草稿订单列表
	findOrderDraftList: API_PREFIX.yjjApi + '/yijiajiaOrder/findOrderDraftList',
	// 删除草稿订单
	delDraftOrder: API_PREFIX.yjjApi + '/yijiajiaOrder/delDraftOrder',
	// 发布订单 （草稿 => 草稿/订单）
	submitDraftOrder: API_PREFIX.yjjApi + '/yijiajiaOrder/submitDraftOrder',
	// 查询是否通过认证
	checkUserAuth: API_PREFIX.yjjApi + '/yijiajiaUserAuth/checkUserAuth',
	// 通讯录-生产商
	addressbookshengchan: API_PREFIX.yjjApi + '/yijiajiaOrder/addressbookshengchan',
	// 通讯录-品牌商
	addressbookpinpai: API_PREFIX.yjjApi + '/yijiajiaOrder/addressbookpinpai',
	
	
	// 订单详情 -- 分成3个接口获取数据
	// 订单详情（数据）  --- 1
	orderDetailsShow: API_PREFIX.yjjApi + '/yijiajiaOrder/orderDetailsShow',
	// 获取面辅料信息    --- 2
	fabicInformationShow: API_PREFIX.yjjApi + '/yijiajiaOrder/fabicInformationShow',
	// 获取面辅料信息2    --- 2
	fabicInformation: API_PREFIX.yjjApi + '/yijiajiaOrder/fabicInformation',
	// 获取补充资料      --- 3
	additionalMaterialsShow: API_PREFIX.yjjApi + '/yijiajiaOrder/additionalMaterialsShow',
    
	
	// 我的基础资料，更改地址、电话，负责人 
	editUserAuth: API_PREFIX.yjjApi + '/yijiajiaUserAuth/editUserAuth',
	// 修改品牌 -- 品牌商
	updateUserAuthCompanyBand: API_PREFIX.yjjApi + '/yijiajiaUserAuth/updateUserAuthCompanyBand',
	
	// 订货会免登录接口
	freeAccessLogin: API_PREFIX.yjjApi + '/yijiajiaUserInfo/freeAccessLogin',
	
	addConferenceApp: API_PREFIX.orderingApi + '/ordering_system_admin/conferenceapp/addConferenceApp',
    
     // 查看受邀活动详情    
    // showConferenceInfo: API_PREFIX.orderingApi + '/ordering_system_admin/conferenceinfo/showConferenceInfo',
    showInviteconferenceinfo: API_PREFIX.yjjApi + '/partnerinvite/showInviteconferenceinfo',
    
    	// 同意或者拒绝邀约      --- 3
    updateInviteState: API_PREFIX.yjjApi + '/partnerinvite/updateInviteState',
	// app配置项接口
	getAppConfigInfo: API_PREFIX.yjjApi + '/app/getAppConfigInfo',
	// app配置项接口2  -- 获取平台联系号码
	appConfigInfo: API_PREFIX.yjjApi + '/app/appConfigInfo',
	// 获取活动列表
	getconferenceInfo: API_PREFIX.yjjApi + '/aboutYijiajiaApp/getconferenceInfo',
	
	// 获取未读消息数量
	saveSystemInfoData: API_PREFIX.yjjApi + '/yijiajiaOrder/saveSystemInfoData',
	
	// 用户消息状态更改
	systemMessageProcessing: API_PREFIX.yjjApi + '/yijiajiaOrder/systemMessageProcessing',
	
	// 获取我的积分
	getMyCreditInfo: API_PREFIX.yjjApi + '/my/getMyCreditInfo',
	
	// 获取我的申报信息
	saveApplicationForApp: API_PREFIX.yjjApi + '/submit/saveApplicationForApp',
	
	// 获取我的申报信息
	saveApplicationInfo: API_PREFIX.yjjApi + '/submit/saveApplicationInfo',
	
	// 检验营业执照是否重复
	checkLicense: API_PREFIX.yjjApi +'/submit/checkLicense',
	
	// 检验是否提交过申报信息
	checkSubmit: API_PREFIX.yjjApi +'/submit/checkSubmit',
	
	// 直播相关  注册信息提交
	regDataForLive: API_PREFIX.yjjApi + '/yijiajiaUserInfo/regDataForLive',
	
	// 入驻云仓提交审核
	applyForDw: API_PREFIX.dwApi + '/admin/applyForDw',
	
	// 入驻云仓提交审核客户详情
	getDwUserInfo: API_PREFIX.dwApi + '/admin/getDwUserInfo',
	
	// 云仓商品列表
	mallItemList: API_PREFIX.dwApi + '/commodity/mallItemList',
	
	// 云仓商品详情
	getMallItemInfo: API_PREFIX.dwApi + '/commodity/getMallItemInfo',

	// 衣加加pc端首页数据
	getStatisticData: API_PREFIX.dwApi + '/dwOrder/getInfoByUserId',

	    
    // 四种订单列表:带total的  
    //品牌商的订单列表
    requestUserOrderListBycount: API_PREFIX.yjjApi + '/yijiajiaOrder/requestUserOrderListBycount',
    // 优先推送订单列表
    priorityPushOrderListByCount: API_PREFIX.yjjApi + '/yijiajiaOrder/priorityPushOrderListByCount',
    // 接加工订单列表
    requestMachiningOrderlistByCount: API_PREFIX.yjjApi + '/yijiajiaOrder/requestMachiningOrderlistByCount',
    // 生产商的订单列表
    requestshengchanUserOrderListByCount: API_PREFIX.yjjApi + '/yijiajiaOrder/requestshengchanUserOrderListByCount',
    
    // 布局云
    getBJYList: API_PREFIX.bujuyun + '/bujuyun/getBJYList',//布局云-列表
    getBuJuYunDetail: API_PREFIX.bujuyun + '/bujuyun/getBuJuYunDetail',//布局云-详情
    
    // 布局云自己网站的接口
    getModelList:"https://www.buju.shop/buju-market/home/getModelList?pageNumber=0&pageSize=30&tokenType=1",//模特列表
    
}

export default api